import store from "@/state/store";

export default [
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/dashboards/default"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("license");
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/404",
    component: require("./views/utility/404").default,
  },
  {
    path: "*",
    redirect: "404",
  },
  {
    path: "/facilitysettings",
    meta: { authRequired: true },
    component: () => import("./views/users/settings"),
  },
  {
    path: "/productcategories",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/productcategories"),
  },
  {
    path: "/viewsales",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/view_sales"),
  },
  {
    path: "/productunits",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/productunits"),
  },
  {
    path: "/products",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/productitemunits"),
  },
  {
    path: "/productitems",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/productitems"),
  },
  {
    path: "/sellproduct",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/sellproduct"),
  },
  {
    path: "/addstock",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/addstock"),
  },
  {
    path: "/stocklevels",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/stocklevels"),
  },
  {
    path: "/systemstock",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/systemstock"),
  },
  {
    path: "/viewstocks",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/viewstocks"),
  },
  {
    path: "/purchases",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/purchases"),
  },
  {
    path: "/reconcilestock",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/reconcilestock"),
  },
  {
    path: "/expiredstock",
    name: 'expiredstock',
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/expiredstock"),
  },
  {
    path: "/printreciept",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/printreciept"),
  },
  {
    path: "/suppliers",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/suppliers"),
  },
  {
    path: "/recordexpense",
    meta: { authRequired: true },
    component: () => import("./views/expenses/record"),
  },
  {
    path: "/expenseitems",
    meta: { authRequired: true },
    component: () => import("./views/expenses/items"),
  },
  {
    path: "/expensecategories",
    meta: { authRequired: true },
    component: () => import("./views/expenses/categories"),
  },
  {
    path: "/viewexpenses",
    meta: { authRequired: true },
    component: () => import("./views/expenses/view"),
  },
  {
    path: "/printinvoice",
    meta: { authRequired: true },
    component: () => import("./views/finance/printinvoice"),
  },
  {
    path: "/accountinvoices",
    meta: { authRequired: true },
    component: () => import("./views/finance/accountinvoices"),
  },
  {
    path: "/groupaccounts",
    meta: { authRequired: true },
    component: () => import("./views/finance/groupaccounts"),
  },
  {
    path: "/dispensemedicine",
    meta: { authRequired: true },
    component: () => import("./views/pharmacy/dispensemedicine"),
  },
  {
    path: "/paymentoptions",
    meta: { authRequired: true },
    component: () => import("./views/settings/paymentoptions"),
  },
  {
    path: "/facilityprofile",
    meta: { authRequired: true },
    component: () => import("./views/settings/profile"),
  },
  {
    path: "/roles",
    meta: { authRequired: true },
    component: () => import("./views/users/roles"),
  },
  {
    path: "/users",
    meta: { authRequired: true },
    component: () => import("./views/users/users"),
  },
  {
    path: "/permissions",
    meta: { authRequired: true },
    component: () => import("./views/users/permissions"),
  },
  {
    path: "/audits",
    meta: { authRequired: true },
    component: () => import("./views/users/audits"),
  },
 
  {
    path: "/paymentsbyoptionreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/paymentsbyoptionreport"),
  },
  {
    path: "/paymentsbymonthreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/paymentsbymonthreport"),
  },
  {
    path: "/paymentsbyuserreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/paymentsbyuserreport"),
  },
  {
    path: "/workloadbyuserreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/workloadbyuserreport"),
  },
  {
    path: "/serviceanalysisreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/serviceanalysisreport"),
  },
  {
    path: "/departmentanalysisreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/departmentanalysisreport"),
  },
  {
    path: "/productsdemand",
    meta: { authRequired: true },
    component: () => import("./views/reports/productsdemand"),
  },
  {
    path: "/productsprofit",
    meta: { authRequired: true },
    component: () => import("./views/reports/productsprofit"),
  },
  {
    path:  "/productsmargin",
    meta: { authRequired:true},
    component: () => import("./views/reports/productsmargin")

  },
  {
    path: "/cashiersales",
    meta: { authRequired: true },
    component: () => import("./views/reports/cashiersales"),
  },
  {
    path: "/cashpaymentsreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/cashpaymentsreport"),
  },
  {
    path: "/personalpaymentsreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/personalpaymentsreport"),
  },
  {
    path: "/pharmacypaymentsreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/pharmacypaymentsreport"),
  },
  {
    path: "/pharmacypurchasereport",
    meta: { authRequired: true },
    component: () => import("./views/reports/pharmacypurchasereport"),
  },
  {
    path: "/pharmacybymonthreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/pharmacybymonthreport"),
  },
  {
    path: "/stockbymonthreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/stockreport"),
  },
  {
    path: "/purchasebysupplierreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/purchasebysupplierreport"),
  },
  {
    path: "/labreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/labreport"),
  },
  {
    path: "/appointmentsreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/appointmentsreports"),
  },
  {
    path: "/expensesreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/expensesreport"),
  },
  {
    path: "/cashflowreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/cashflowreport"),
  },
  {
    path: "/diagnosisanalysisreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/diagnosisanalysisreport"),
  },
  {
    path: "/customers",
    meta: { authRequired: true },
    component: () => import("./views/customers/view_customers"),
  },
  {
    path: "/cashiersprofit",
    meta: { authRequired: true },
    component: () => import("./views/reports/cashiersprofit"),
  },
  {
    path: "/subscriptions",
    meta: { authRequired: true },
    component: () => import("./views/settings/subscriptions"),
  },
  {
    path: '/expired-license',
    name: 'expired-license',
    meta: { authRequired: true },
    component: () => import('./views/account/license-expired')
  },
  {
    path: '/payments',
    name: 'payments',
    meta: { authRequired: true },
    component: () => import('./views/account/payments')
  },
];
